import React, { useState } from 'react';
import { mockCashTransactions, formatCurrency } from '../../../services/mockData';

const CashbookReport = () => {
  const [fromDate] = useState('01-04-2025');
  const [toDate] = useState('01-02-2026');

  const totalDr = mockCashTransactions.reduce((s, t) => s + t.dr, 0);
  const totalCr = mockCashTransactions.reduce((s, t) => s + t.cr, 0);

  return (
    <div className="fade-in">
      <div className="page-header">
        <div className="breadcrumb">Bank &amp; Cash Reports <span>/ Cash Book Report</span></div>
        <h2>Cash Book Report</h2>
      </div>

      <div className="filter-bar">
        <div className="form-group">
          <label>Select Ledger</label>
          <select className="form-control">
            <option>CASH – CASH IN HAND</option>
          </select>
        </div>
        <div className="form-group">
          <label>From</label>
          <input type="text" className="form-control" defaultValue={fromDate} />
        </div>
        <div className="form-group">
          <label>To</label>
          <input type="text" className="form-control" defaultValue={toDate} />
        </div>
        <div className="form-group" style={{ justifyContent: 'flex-end' }}>
          <button className="btn btn-primary">🔍 Search</button>
        </div>
        <div className="form-group" style={{ justifyContent: 'flex-end' }}>
          <div className="btn-group">
            <button className="btn btn-warning btn-sm">🖨️ Print / Save as PDF</button>
            <button className="btn btn-success btn-sm">📊 Export To Excel</button>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="report-header">
          <h3>Vitthal Plaza Co-Op Housing Society LTD</h3>
          <p>Registration Number: TNADO(M/HSG/TC)/25796/YEAR-2023</p>
          <p>dr Sagar(Dombivali)</p>
          <p style={{ fontWeight: '700', marginTop: '6px' }}>
            CASH – A/c CASHINHAND for Financial Year: 2025-2026<br />
            On Dated: 01-02-2026 For Period: <b>01-04-2025 to 01-02-2026</b>
          </p>
        </div>

        <div className="table-wrapper">
          <table>
            <thead>
              <tr>
                <th>Posted Date</th>
                <th>Particulars</th>
                <th>Type / No</th>
                <th className="amount">Dr</th>
                <th className="amount">Cr</th>
                <th className="amount">Balance</th>
              </tr>
            </thead>
            <tbody>
              {mockCashTransactions.map((t, i) => (
                <tr key={i}>
                  <td>{t.postedDate}</td>
                  <td>
                    <div>{t.particulars.split('\n')[0]}</div>
                    {t.particulars.split('\n')[1] && (
                      <div style={{ fontSize: '11px', color: '#718096' }}>{t.particulars.split('\n')[1]}</div>
                    )}
                  </td>
                  <td>{t.type}</td>
                  <td className="amount dr">{t.dr > 0 ? formatCurrency(t.dr) : ''}</td>
                  <td className="amount cr">{t.cr > 0 ? formatCurrency(t.cr) : ''}</td>
                  <td className="amount" style={{ fontWeight: '700' }}>
                    {formatCurrency(t.balance)} <span className={t.balType === 'DR' ? 'dr' : 'cr'} style={{ fontSize: '10px' }}>{t.balType}</span>
                  </td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan={3} style={{ textAlign: 'right', fontWeight: '800' }}>Total</td>
                <td className="amount dr">{formatCurrency(totalDr)}</td>
                <td className="amount cr">{formatCurrency(totalCr)}</td>
                <td className="amount" style={{ fontWeight: '800' }}>
                  {formatCurrency(mockCashTransactions[mockCashTransactions.length - 1]?.balance)} DR
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  );
};

export default CashbookReport;
